import Widget from 'components/Widget/Widget';
import React from 'react';
import PostbackReports from './components/PostbackReports';
import PostbacksFilters from './components/PostbacksFilters';

const PostbackQuickReports = ({ height = 500, data, index, configuration, load_chart }) => {
  return (
    <Widget
      icon={<img src='/icons/integrations/postbacks.svg' className='w-5 h-5 ' />}
      tableWidget
      widget_key={'postback_reports_charts' + index}
      filterComponent={PostbacksFilters}
      title={data.title}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      showDatePicker
      disableAccountsFilter
      className='h-full'
      data={data}
      load_chart={load_chart}
      showCustomDesign={load_chart}
      showWidgetTypeSwitcher
      changeAreaChartDesign
      position={data?.position}
      dashboard_widget_key={data?.key}
      changeMetricsDesign={false}
    >
      
      <PostbackReports height={height} widget_key={'postback_reports_charts' + index} data={data} />
    </Widget>
  );
};

export default PostbackQuickReports;
